(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-hub-latest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TIMEOUT_MS = 6000;

    function withTimeout(url, options) {
      var controller = new AbortController();
      var timer = setTimeout(function () {
        controller.abort();
      }, TIMEOUT_MS);
      options = options || {};
      options.signal = controller.signal;
      return fetch(url, options).finally(function () {
        clearTimeout(timer);
      });
    }

    /* Storefront API of the store that owns the feed. Unlike the Atom feed it allows requests from
       other sites, and it answers blog queries without a token. A token is sent only when one is set. */
    function fromStorefrontApi(feed, token, limit) {
      var handle = (feed.pathname.match(/\/blogs\/([^/.]+)/) || [])[1];
      if (!handle) return Promise.reject(new Error('No blog handle in feed URL'));
      var query =
        'query($handle: String!, $first: Int!) { blog(handle: $handle) { articles(first: $first, sortKey: PUBLISHED_AT, reverse: true) { nodes { title onlineStoreUrl handle } } } }';
      var headers = { 'Content-Type': 'application/json' };
      if (token) headers['X-Shopify-Storefront-Access-Token'] = token;
      return withTimeout(feed.origin + '/api/2026-07/graphql.json', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: query, variables: { handle: handle, first: limit } }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Storefront API ' + response.status);
          return response.json();
        })
        .then(function (json) {
          var nodes = (((json.data || {}).blog || {}).articles || {}).nodes || [];
          return nodes.map(function (node) {
            return {
              title: node.title,
              url: node.onlineStoreUrl || feed.origin + '/blogs/' + handle + '/' + node.handle,
            };
          });
        });
    }

    /* The blog's Atom feed. Entries are already sorted newest first. */
    function fromAtomFeed(feed, limit) {
      return withTimeout(feed.href, { headers: { Accept: 'application/atom+xml' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Feed ' + response.status);
          return response.text();
        })
        .then(function (text) {
          var xml = new DOMParser().parseFromString(text, 'application/xml');
          if (xml.querySelector('parsererror')) throw new Error('Feed is not valid XML');
          return Array.prototype.slice.call(xml.querySelectorAll('entry'), 0, limit).map(function (entry) {
            var title = entry.querySelector('title');
            var link = entry.querySelector('link[rel="alternate"]') || entry.querySelector('link');
            return { title: title ? title.textContent : '', url: link ? link.getAttribute('href') : '' };
          });
        });
    }

    function render(container, feed, articles, limit) {
      var valid = articles.filter(function (article) {
        return article.title && article.title.trim() && article.url && article.url.indexOf(feed.origin + '/') === 0;
      });
      if (valid.length < limit) throw new Error('Not enough articles');

      var existing = container.querySelectorAll('[data-ee-latest-item]');
      var arrow = container.querySelector('.ee-latest__arrow');
      existing.forEach(function (item) {
        item.remove();
      });
      var list = container.querySelector('[data-ee-latest-list]') || container;
      valid.slice(0, limit).forEach(function (article, index) {
        var link = document.createElement('a');
        link.className = 'ee-latest__item';
        link.setAttribute('data-ee-latest-item', '');
        link.href = article.url;

        var number = document.createElement('span');
        number.className = 'ee-latest__num';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = '0' + (index + 1);

        var title = document.createElement('span');
        title.className = 'ee-latest__title';
        title.textContent = article.title.trim();

        link.appendChild(number);
        link.appendChild(title);
        if (arrow) link.appendChild(arrow.cloneNode(true));
        list.appendChild(link);
      });
    }

    function load(container) {
      if (container.dataset.eeLatestLoaded) return;
      container.dataset.eeLatestLoaded = 'true';

      var feed;
      try {
        feed = new URL(container.dataset.feedUrl);
      } catch (error) {
        return;
      }
      if (feed.protocol !== 'https:') return;

      var limit = parseInt(container.dataset.limit, 10) || 3;
      var token = container.dataset.storefrontToken;
      var request = fromStorefrontApi(feed, token, limit)
        .then(function (articles) {
          if (articles.length < limit) throw new Error('Not enough articles');
          return articles;
        })
        .catch(function () {
          return fromAtomFeed(feed, limit);
        });

      request
        .then(function (articles) {
          render(container, feed, articles, limit);
        })
        .catch(function () {
          /* Keep the fixed links that are already on the page. */
        });
    }

    function init() {
      document.querySelectorAll('[data-ee-latest-feed]').forEach(load);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-hub-notice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Redirects are skipped in the theme editor so the section stays editable. */
    if (window.Shopify && window.Shopify.designMode) return;

    var notice = document.querySelector('[data-ee-notice]');
    if (!notice) return;

    function isSafe(url) {
      return /^https:\/\//.test(url) || /^\/(?!\/)/.test(url);
    }

    var target = (notice.dataset.redirectUrl || '').trim();

    if (!target) {
      var path = window.location.pathname.replace(/\/+$/, '').toLowerCase() || '/';
      (notice.dataset.redirectRules || '').split('\n').some(function (line) {
        var parts = line.split('=>');
        if (parts.length !== 2) return false;
        var from = parts[0].trim().replace(/\/+$/, '').toLowerCase();
        var to = parts[1].trim();
        if (!from) return false;
        if (path === from || path.indexOf(from + '/') === 0) {
          target = to;
          return true;
        }
        return false;
      });
    }

    if (target && isSafe(target) && target !== window.location.pathname) {
      window.location.replace(target);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
